<!-- ======= Skills Section ======= -->
<section id="skills" class="skills section-bg">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Habilidades</h2>
      <p>
        Cuento con experiencia y conocimiento de aplicaciones orientados a servicios web, Api RestFull:
        <span>BackEnd:</span>  Lenguaje de programación Javascript, NodeJs, NestJs,
        Gestor de Base de datos con las herramientas SQLServer y MySQL.
        <span>FrontEnd:</span>  Cuento con conocimientos en HTML, CSS, JS, manejo el framework de Angular
        para aplicaciones SPA, y consumir servicios RestFull.
      </p>
    </div>

    <div class="row skills-content">
      <div class="col-lg-6"  *ngFor="let skill of skills"  >
        <div class="progress">
          <span class="skill">{{ skill.skill }} <i class="val">{{skill.progress}}%</i></span>
          <div class="progress-bar-wrap">
            <div
              class="progress-bar"
              role="progressbar"
              [style.width.%]="skill.progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

      </div>

    </div>
  </div>

</section>
<!-- End Skills Section -->
